import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

export type SetIsFilterNavOpenParameter = {
    isOpen?: boolean;
};

type HandlerType = Handler<SetIsFilterNavOpenParameter>;

export const DispatchSetIsFilterNavOpen: HandlerType = props => {
    props.dispatch({
        type: "Toolkit/Pages/ProductList/SetIsFilterNavOpen",
        isOpen: props.parameter.isOpen,
    });
};

export const chain = [DispatchSetIsFilterNavOpen];

const setIsFilterNavOpen = createHandlerChainRunner(chain, "SetIsFilterNavOpen");

export default setIsFilterNavOpen;
